import React from 'react';

import { ContainerRow, ContainerColumn } from './styles';
import { Spinner } from '../../../components/Spinner/spinner';
import CommentDisplay from './commentDisplay';

export default function CommentList({ commentIds, loading, commentLevel = 0 }) {
  return (
    <ContainerRow>
      <ContainerColumn>
        {loading && <Spinner />}
        {!loading &&
          commentIds &&
          commentIds.map((commentId) => (
            <CommentDisplay key={commentId} commentId={commentId} commentLevel={commentLevel} />
          ))}
      </ContainerColumn>
    </ContainerRow>
  );
}
